<template>
    <div class="scroll">
      <messaging-bar :noBorder="true" class="topbar message-bar">
        <div class="info">
          <div class="user-image">
            <img src="@/assets/green-house.png" class="is-40x40 margin-zero" alt="">
          </div>
          <div class="text-info">
            <a><strong>Greenhouse</strong></a>
            <span>Integration description and instructions...</span>
          </div>
        </div>
      </messaging-bar>
      <div class="px-20">
          <div class="control is-flex field align-center">
            <toggle v-model="autoPost" :isEditable="true"></toggle> <label class="ml-10">Automatically post jobs from Greenhouse to HireVibes</label>
          </div>
        <div class="control is-flex field align-center">
          <toggle v-model="autoApplicants" :isEditable="true"></toggle> <label class="ml-10">Automatically send applicants from Greenhouse to HireVibes</label>
        </div>
        <div class="field">
          <text-field label="Greenhouse Email" placeholder="Email" v-model="email" :error="emailError" />
        </div>
        <div class="field">
          <text-field label="Greenhouse API Key" v-model="apiKey" :error="apiKeyError" />
        </div>
        <div class="field">
          <field label="Default Job type">
            <div class="control is-expanded is-fullwidth">
              <div class="select is-fullwidth">
                <select v-model="type">
                  <option value="">Choose Job Type</option>
                  <option v-for="jt in jobTypes" :key="jt.id" :value="jt.id">
                    {{ jt.name }}
                  </option>
                </select>
              </div>
            </div>
          </field>
        </div>
        <div v-if="!greenHouseConnected">
          <button :disabled="loading" class="button is-primary is-fullwidth" @click="saveHandler"><spinner size="small" v-if="loading" ></spinner><p v-else>SAVE</p></button>
        </div>
        <hr>
        <label>Heading and instructions...</label>
        <div class="field mt-20">
          <text-field label="Webook URL" v-model="webhookUrl" readonly />
        </div>
        <div class="field">
          <div class="columns">
            <div class="column">
              <text-field label="Auth username" v-model="authUsername" readonly />
            </div>
            <div class="column">
              <text-field label="Auth password" v-model="authPassword" readonly />
            </div>
          </div>
        </div>
        <div>
          <p>
            Your Auth password will only be visible now and you will not be able to access it again.
            Please record ir in a safe place. If you lose it you will be required to generate a new password
          </p>
        </div>
      </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import Spinner from 'vue-simple-spinner'
import UserImage from '@/components/general/user-image'
import MessagingBar from '@/components/messaging/messaging-bar'
import Field from '@/components/general/field'
import Toggle from '@/components/toggle'
import TextField from '@/components/general/text-field'
import {emailRegex} from '@/constants/regex'

export default {
  name: 'GreenHouseForm',
  components: {
    UserImage,
    MessagingBar,
    Field,
    Toggle,
    TextField,
    Spinner
  },
  props: {
    toggleGreenHouseModal: {
      type: Object
    },
    companies: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapActions('greenHouse', ['attachGreenHouse']),
    ...mapMutations('greenHouse', [ 'setAutoPost', 'setAutoApplicants', 'setEmail', 'setApiKey',
      'setAuthUsername', 'setAuthPassword', 'setType', 'setEmailError', 'setApiKeyError', 'setCompanyId']),
    validations () {
      if (this.formEmail.length === 0) {
        this.setEmailError('Email is required')
        return false
      } else if (!String(this.formEmail)
        .toLowerCase()
        .match(emailRegex)) {
        this.setEmailError('Enter valid email')
        return false
      } else if (this.apiKey.length === 0) {
        this.setApiKeyError('API Key is required')
        return false
      }
      return true
    },
    saveHandler () {
      const validations = this.validations()
      if (!validations) {
        return false
      }
      this.attachGreenHouse({toggle: this.toggleGreenHouseModal, companyId: this.user.companyId})
    }
  },
  computed: {
    ...mapState('domain', ['jobTypes']),
    ...mapState('users', ['user']),
    ...mapState('greenHouse', {
      formAutoPost: 'autoPost',
      formAutoApplicants: 'autoApplicants',
      formEmail: 'email',
      formApiKey: 'apiKey',
      formWebhookUrl: 'webhookUrl',
      formAuthUsername: 'authUsername',
      formAuthPassword: 'authPassword',
      emailError: 'emailError',
      apiKeyError: 'apiKeyError',
      formType: 'type',
      loading: 'loading',
      greenHouseConnected: 'greenHouseConnected',
      formCompanyId: 'companyId'
    }),
    autoPost: {
      get () { return this.formAutoPost },
      set (value) { this.setAutoPost(value) }
    },
    autoApplicants: {
      get () { return this.formAutoApplicants },
      set (value) { this.setAutoApplicants(value) }
    },
    email: {
      get () { return this.formEmail },
      set (value) { this.setEmail(value) }
    },
    apiKey: {
      get () { return this.formApiKey },
      set (value) { this.setApiKey(value) }
    },
    webhookUrl: {
      get () { return this.formWebhookUrl },
      set (value) { }
    },
    authUsername: {
      get () { return this.formAuthUsername },
      set (value) { }
    },
    authPassword: {
      get () { return this.formAuthPassword },
      set (value) { }
    },
    type: {
      get () { return this.formType },
      set (value) { this.setType(value) }
    }
  }

}
</script>

<style scoped lang="scss">
@import '~@/styles/defaults.scss';
.info {
  display: flex;
  flex-direction: row;
}
.text-info {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-bottom: 10px;
  span {
    color: #888;
  }
}
.message-bar{
  height: auto !important; min-height: auto !important;
}

.topbar {
  display: flex;
a {
  color: black;
}
}

.mt-20{
  margin-top: 20px;
}

.px-20{
  padding: 20px
}
.ml-10{
  margin-left: 20px
}
.align-center{
  align-items: center;
}
.scroll{
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/green-house-form.vue